export const COMPONENT_NAME_MAPPING = {
  AboutSection: 'about-section',
  PaymentPartnerSection: 'payment-partner-section',
  TopPerformanceSection: 'top-performance-section',
  GameCarouselSection: 'game-carousel-section',
  FirstFoldBanner: 'first-fold-banner',
  RecentGamesSection: 'recent-games-section',
  BenefitsStrip: 'benefits-strip'
}

export const PAGE_NAME_MAPPING = {
  HOME: 'homePage',
  ACCOUNT: 'accounts'
}

export const ACCOUNT_TAB_KEYS = {
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
  PENDING_WITHDRAWALS: 'pending-withdrawals',
  DASHBOARD: 'dashboard',
  ACCOUNT_INFO: 'account-info',
  VERIFY_ACCOUNT: 'account-verify',
  TRANSACTIONS: 'transaction',
  LIMITS: 'limits',
  FAVOURITE_GAMES: 'favourite-games'
}

export const BONUS_CARD_VARIANTS = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3'
}

export const CLAIMABLE_BONUSES_VARIANT = {
  V1: 'v1',
  V2: 'v2'
}

export const DEPOSIT_BONUS_LIST_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const GAME_CARD_VARIANTS = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3'
}

export const PARTNER_LOGOS_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const FOOTER_VARIANTS = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3'
}

export const LOADER_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const BUTTON_LOADING_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const TOP_PERFORMANCE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const GAMEPLAY_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const HOME_PAGE_GAMES_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const HEADER_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const HEADER_NAV_ITEMS = {
  HOME: 'home',
  SPORTS: 'sports',
  PROMOTIONS: 'promotions',
  LOYALTY: 'loyalty',
  VIP: 'vip',
  CALENDAR: 'calendar'
}

export const ACCOUNT_INFO_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const PAYMENT_RECEIPT = {
  V1: 'v1',
  V2: 'v2'
}

export const ACCOUNT_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const DASHBOARD_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const ACTIVE_BONUS_VARIANT = {
  V1: 'v1',
  V2: 'v2'
}

export const WITHDRAW_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const BANNER_VARIANT = {
  V1: 'v1',
  V2: 'v2'
}

export const SLIDER_VARIANT = {
  V1: 'v1',
  V2: 'v2'
}

export const ABOUT_US_VARIANT = {
  V1: 'v1',
  V2: 'v2'
}

export const DATE_BIRTH_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const VIP_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
  V4: 'v4'
}

export const AFFILIATE_PAGE_VARIANTS = {
  V1: 'v1'
}

export const COOKIE_MODAL_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const BLOCKED_COUNTRY_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const GAME_MODAL_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const CASHIER_IFRAME_MODAL_VARIANT = {
  V1: 'v1',
  V2: 'v2'
}

export const GAME_PLAY_LIMIT_MODAL = {
  V1: 'v1',
  V2: 'v2'
}

export const CANCEL_MODAL_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const LIMITS_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const DEPOSIT_LIMIT_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const TAKE_A_BREAK_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const SELF_EXCLUSION_PAGE_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const LIMIT_CONFIRMATION_MODAL_VARIANTS = {
  V1: 'v1',
  V2: 'v2'
}

export const BREAK_POINTS = {
  xl: 'xl',
  xlm: 'xlm',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
}

export const SITE_MAINTENANCE_VARIANTS = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3'
}

export const BREAK_POINTS_SIZES = {
  xl: 2920,
  xlm: 1349,
  lg: 1199,
  md: 991,
  sm: 767,
  xs: 480
}

export const GAME_FILTER_SUPPORT_TYPE = {
  PROVIDER: 'PROVIDER',
  STUDIO: 'STUDIO',
  PROVIDER_AND_STUDIO: 'PROVIDER_AND_STUDIO'
}

export const GAME_CATEGORY_EXTRA_TAB_KEYS = {
  FAVORITES: 'favorites',
  RECENT_GAMES: 'recent-games'
}

export const GAME_CATEGORY_EXTRA_TAB_SET = new Set([GAME_CATEGORY_EXTRA_TAB_KEYS.FAVORITES, GAME_CATEGORY_EXTRA_TAB_KEYS.RECENT_GAMES])

// Default checked state of the signup consent checkboxes.
// Tenants override any of these keys via `signupTermsAndConditions` in public/config/[tenant].json
export const SIGNUP_TERMS_AND_CONDITIONS_DEFAULTS = {
  privacyPolicy: false,
  termsAndConditions: false,
  newsLetter: true,
  sms: true,
  newsletterAndSms: true
}
